import { all, takeLatest, call, put, select } from 'redux-saga/effects'
import types from '../actions/types'
import { USER_FIELD_TYPES } from '../helpers/constants'
import * as actions from '../actions/userFields'
import * as dataActions from '../actions/data'
import * as snackbarActions from '../actions/snackbar'
import { generalError } from '../actions'

export default (api) => {

  function * loadUserFieldsWorker ({ }) {
    try {
      const params = { }
      const fields = { default: true }
      const response = yield call(api.userFields.get, params, fields)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.loadUserFieldsSuccess(data.result))
        },
        function * onFail (key, message, code) {
          yield put(actions.loadUserFieldsFailure(message, code))
        }
      )

    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  // Shaping of action is done by action function parameters
  function * addUserFieldWorker({ ...params }) {
    try {
      // We need to pull and set the category type
      params.typeId = yield select(state => state.settingsContext.tagCategories.filter(c => c.id === params.categoryId).pop().type)
      const response = yield call(api.userFields.add, params)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          const tag = data.result[0]
          yield put(actions.addUserFieldSuccess(tag))
          yield put(snackbarActions.snackbarMessage(`${params.name} created`))
          yield updateUserfieldState(tag.type.id)
        },
        function * onFail (key, message, code) {
          yield put(actions.addUserFieldFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`${params.name} failed to save`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  // Shaping of action is done by action function parameters
  function * updateUserFieldWorker({...params }) {
    try {
      const response = yield call(api.userFields.update, params)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          const tag = data.result[0]
          yield put(actions.updateUserFieldSuccess(tag))
          yield put(snackbarActions.snackbarMessage(`${params.name} updated`))
          yield updateUserfieldState(tag.type.id)
        },
        function * onFail (key, message, code) {
          yield put(actions.updateUserFieldFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`${params.name} failed to update`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * moveUserFieldWorker ({ tagId, tagName, categoryId, categoryName }) {
    try {
      const params = { tagId, categoryId }
      const fields = { default: true }
      const response = yield call(api.userFields.move, params, fields)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.moveUserFieldSuccess(data.result))
          yield put(snackbarActions.snackbarMessage(`${tagName} moved to ${categoryName}`))
        },
        function * onFail (key, message, code) {
          yield put(actions.moveUserFieldFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`${tagName} failed to move`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * deleteUserFieldWorker ({ id, name }) {
    try {
      const params = { id }
      const fields = { default: true }
      const response = yield call(api.userFields.delete, params, fields)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.deleteUserFieldSuccess(data.result))
          yield put(snackbarActions.snackbarMessage(`'${name}' deleted`))
          yield updateUserfieldState(data.result.type.id)
        },
        function * onFail (key, message, code) {
          yield put(actions.deleteUserFieldFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`'${name}' could not be deleted`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * reorderUserFieldsWorker ({ ids }) {
    try {
      const params = { ids }
      const fields = { default: true }
      const response = yield call(api.userFields.reorder, params, fields)
      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.reorderUserFieldSuccess(data.result))
        },
        function * onFail (key, message, code) {
          yield put(actions.reorderUserFieldFailure(message, code))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * reorderUserFieldCategoriesWorker ({ ids }) {
    try {
      const params = { ids }
      const fields = { default: true }
      const response = yield call(api.userFields.reorder, params, fields)
      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.reorderUserFieldSuccess(data.result))
        },
        function * onFail (key, message, code) {
          yield put(actions.reorderUserFieldFailure(message, code))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * addUserFieldCategoryWorker ({ name, typeId }) {
    try {
      const params = { name, typeId }
      const fields = { default: true }
      const response = yield call(api.userFieldCategories.add, params, fields)
      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.addUserFieldCategorySuccess(data.result))
          yield put(snackbarActions.snackbarMessage(`${name} saved`))
          yield updateUserfieldState(data.result.type)
        },
        function * onFail (key, message, code) {
          yield put(actions.addUserFieldCategoryFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`${name} failed to save`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }
  // Shaping of action is done by action function parameters
  function * updateUserFieldCategoryWorker({...params }) {
    try {
      const fields = { default: true }
      const response = yield call(api.userFieldCategories.update, params, fields)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.updateUserFieldCategorySuccess(data.result))
          yield updateUserfieldState(data.result.type)
        },
        function * onFail (key, message, code) {
          yield put(actions.updateUserFieldCategoryFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`${params.name} failed to update`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * deleteUserFieldCategoryWorker ({ name, id, replaceId }) {
    try {
      const params = { name, id, replaceId }
      const fields = { default: true }
      const response = yield call(api.userFieldCategories.delete, params, fields)
      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.deleteUserFieldCategorySuccess(data.result))
          yield put(snackbarActions.snackbarMessage(`${name} deleted`))
          //user fields should have moved about.  Refresh from the server.
          yield loadUserFieldsWorker({ })
          yield updateUserfieldState(data.result.type)
        },
        function * onFail (key, message, code) {
          yield put(actions.deleteUserFieldCategoryFailure(message, code))
          yield put(snackbarActions.snackbarMessage(`${name} failed to delete - ${message}`))
        }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * loadUserFieldCategoriesWorker ({ }) {
    try {
      const params = { }
      const fields = { }
      const response = yield call(api.userFieldCategories.get, params, fields)

      yield api.handleResponse(
        response,
        function * onOk (key, data) {
          yield put(actions.loadUserFieldCategoriesSuccess(data.result))
        },
        function * onFail (key, message, code) {
          yield put(actions.loadUserFieldCategoriesFailure(message, code))
        }
      )

    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * updateUserfieldState(typeId) {
    switch (typeId) {
      case USER_FIELD_TYPES.COMPANY_USER_FIELD.id:
        yield put(dataActions.loadCompanyDataFields())
        break
      case USER_FIELD_TYPES.CONTACT_USER_FIELD.id:
        yield put(dataActions.loadContactDataFields())
        break
      case USER_FIELD_TYPES.QUOTE_USER_FIELD.id:
        yield put(dataActions.loadQuoteDataFields())
        break
      case USER_FIELD_TYPES.QUOTE_ITEM_USER_FIELD.id:
        yield put(dataActions.loadQuoteItemDataFields())
        break
      case USER_FIELD_TYPES.PURCHASE_ORDER_USER_FIELD.id:
        yield put(dataActions.loadPurchasingFields())
        break
      case USER_FIELD_TYPES.PURCHASE_ORDER_ITEM_USER_FIELD.id:
        yield put(dataActions.loadPurchasingItemFields())
        break
      default: return
    }
  }

  function * watcher() {
    try {
      yield all([
        takeLatest(types.USERFIELDS_READ_ATTEMPT, loadUserFieldsWorker),
        takeLatest(types.USERFIELDS_ADD_ATTEMPT, addUserFieldWorker),
        takeLatest(types.USERFIELDS_UPDATE_ATTEMPT, updateUserFieldWorker),
        takeLatest(types.USERFIELDS_DELETE_ATTEMPT, deleteUserFieldWorker),
        takeLatest(types.USERFIELDS_MOVE_ATTEMPT, moveUserFieldWorker),
        takeLatest(types.USERFIELDS_REORDER_ATTEMPT, reorderUserFieldsWorker),
        takeLatest(types.USERFIELDS_CATEGORY_READ_ATTEMPT, loadUserFieldCategoriesWorker),
        takeLatest(types.USERFIELDS_CATEGORY_REORDER_ATTEMPT, reorderUserFieldCategoriesWorker),
        takeLatest(types.USERFIELDS_CATEGORY_ADD_ATTEMPT, addUserFieldCategoryWorker),
        takeLatest(types.USERFIELDS_CATEGORY_DELETE_ATTEMPT, deleteUserFieldCategoryWorker),
        takeLatest(types.USERFIELDS_CATEGORY_UPDATE_ATTEMPT, updateUserFieldCategoryWorker),
      ])
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  return {
    watcher,
    loadUserFieldsWorker,
    loadUserFieldCategoriesWorker,
    moveUserFieldWorker,
    reorderUserFieldsWorker,
    reorderUserFieldCategoriesWorker,
  }
}
